import { classNames } from 'src/helpers/utilities'

type LabelProps = {
  label: string
  color: 'green' | 'gray' | 'blue'
}

export default function Label({ label, color }: LabelProps) {
  return (
    <span
      className={classNames(
        color === 'green'
          ? 'text-green-500 bg-green-100'
          : color === 'gray'
          ? 'text-gray-500 bg-gray-100'
          : 'text-blue-500 bg-blue-100',
        `flex-shrink-0 inline-block px-2 py-0.5 text-xs font-medium rounded-sm align-text-top`
      )}
    >
      {label}
    </span>
  )
}
